import { ContextualTabbedSettings } from '@components'

import { Link, Tooltip } from '@billy/design-system'
import { Button, YStack } from '@shinetools/lumen-react'
import { FC, PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

import { Organization } from '@modules-deprecated/app/organization/types/organization'

import { getOrganizationViewUrl } from '../../../../../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../../../../../utils/routing/reactRoute'
import { LearnMoreTranslation } from '../../../elements/LearnMoreTranslation'

const { MainSettingCta } = ContextualTabbedSettings

export interface ActivatePDPEInvoicingCTAContentProps {
  organization: Organization
  disabled?: boolean
  tooltip?: string
}

const ActivatePDPEInvoicingCTAContent: FC<PropsWithChildren<ActivatePDPEInvoicingCTAContentProps>> = ({
  organization,
  tooltip,
  disabled,
}) => {
  const { t } = useTranslation()

  if (!tooltip) {
    return (
      <Link
        href={getOrganizationViewUrl(organization.url, reactRoute.organization.eInvoicing.getMainRoute())}
        disabled={disabled}
      >
        <Button disabled={disabled} variant="filled" label={t('einvoicing.settings.activation.activate_cta')} />
      </Link>
    )
  }

  if (disabled) {
    return (
      <Tooltip label={tooltip}>
        <Button disabled variant="filled" label={t('einvoicing.settings.activation.activate_cta')} />
      </Tooltip>
    )
  }
}

export const ActivatePDPEInvoicingCTA: FC<PropsWithChildren<ActivatePDPEInvoicingCTAContentProps>> = ({
  children,
  organization,
  disabled,
  tooltip,
}) => {
  return (
    <YStack>
      <MainSettingCta
        description={
          <LearnMoreTranslation
            i18nKey="einvoicing.settings.activation.activate_description"
            linkKey="einvoicing.settings.activation.activate_link"
          />
        }
        ctaContent={
          <ActivatePDPEInvoicingCTAContent tooltip={tooltip} disabled={disabled} organization={organization} />
        }
      />

      {children}
    </YStack>
  )
}
